<template>
  <div class="materialCenter">
    <el-card>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="图片" name="first">
          <photoMaterial v-if="activeName == 'first'" @attachmentSizeChange="getAttachmentByType()"></photoMaterial>
        </el-tab-pane>
        <el-tab-pane label="视频" name="second">
          <videoMaterial v-if="activeName == 'second'" @attachmentSizeChange="getAttachmentByType()"></videoMaterial>
        </el-tab-pane>
        <el-tab-pane label="讲义" name="three">
          <material v-if="activeName == 'three'" @attachmentSizeChange="getAttachmentByType()"></material>
        </el-tab-pane>
      </el-tabs>
      <div class="progress-position">
        <div class="materialCenter-flex">
          <div :key="attachmentSizeForm[1]">空间容量：{{ ((attachmentSizeForm[1] + attachmentSizeForm[2] + attachmentSizeForm[3]) / 1024 / 1024 / 1024).toFixed(4) }}GB/{{ (agentInfp.videoCapacity / 1024 / 1024 / 1024).toFixed(4) }}</div>
          <!-- <div>
            <span class="operItem">详情</span>
            <span class="operItem">扩容</span>
          </div> -->
        </div>
        <div class="progress">
          <div class="progress-absolute" :style="'width:' + (attachmentSizeForm[1] + attachmentSizeForm[2] + attachmentSizeForm[3]) / (1000 * 1024 * 1024 * 1024) * 100 + '%'">
            <div class="progress-red" :style="'width:' + (attachmentSizeForm[1] / (attachmentSizeForm[1] + attachmentSizeForm[2] + attachmentSizeForm[3])) * 100 + '%'"></div>
            <div class="progress-yellow" :style="'width:' + (attachmentSizeForm[2] / (attachmentSizeForm[1] + attachmentSizeForm[2] + attachmentSizeForm[3])) * 100 + '%'"></div>
            <div class="progress-ching" :style="'width:' + (attachmentSizeForm[3] / (attachmentSizeForm[1] + attachmentSizeForm[2] + attachmentSizeForm[3])) * 100 + '%'"></div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import photoMaterial from "./photoMaterial.vue";
import videoMaterial from "./videoMaterial.vue";
import material from "./material.vue";
export default {
  components: { photoMaterial, videoMaterial, material },
  data () {
    return {
      activeName: "first",
      attachmentSizeForm: {},
      agentInfp: {},
    };
  },
  methods: {
    getAttachmentByType () {
      this.api.fodderGroupInfo.getAttachmentByType().then(result => {
        if (result.success) {
          this.attachmentSizeForm = result.data;
          console.log(result.data)
        } else {
          this.$message.error(result.message)
        }
      })
    },
    handleClick (tab, event) {
      console.log(tab, event);
    }
  },
  mounted () {
    this.getAttachmentByType();
    this.api.agentInfo.getIndexAgentInfo().then((res) => {
      if (res.success) {
        this.agentInfp = res.data
      } else {
        this.$message.error(res.message);
      }
    });
    if (this.$route.query.type == 1) {
      this.activeName = "first";
    } else if (this.$route.query.type == 2) {
      this.activeName = "second";
    } else if (this.$route.query.type == 3) {
      this.activeName = "three";
    } else {
      this.activeName = "first";
    }
  }
};
</script>
<style scoped>
.materialCenter {
  position: relative;
}

.progress-position {
  position: absolute;
  right: 20px;
  top: 25px;
}

.progress-absolute {
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  max-width: 100% !important;
}

.materialCenter-flex {
  display: flex;
  justify-content: space-between;
}

.progress {
  position: relative;
  margin-top: 5px;
  background-color: #ebeef5;
  border-radius: 100px;
  height: 8px;
  width: 300px;
}

.progress-red {
  position: relative;
  background: #ff646B;
  z-index: 10;
  height: 8px;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
}

.progress-yellow {
  position: relative;
  background: #ffc349;
  z-index: 10;
  height: 8px;
}

.progress-ching {
  position: relative;
  background: #41d497;
  z-index: 10;
  height: 8px;
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/materialCenter/index.vue